<!--
 * @Date: 2020-12-16 09:00:00
 * @Author: MX
 * @LastAuthor: WZ
 * @LastEditTime: 2020-12-28 18:30:30
 * @Description:关于我们
-->
<template>
    <div class="aboutUs main-wrap">
        <div class="aboutUs-wrap">
            <div class="main-left">
                <div class="main-left-header">
                    <span class="line"></span>
                    关于我们
                </div>
                <div class="main-left-aside">
                  <div class="main-left-aside-item" v-for="(item,index) in asideList" :key="index">
                      <div class="subTitle" v-for="(subItem,subIndex) in item.subTitle" :key="subIndex" :class="{first:subIndex===0,active:tabNum === subIndex}"
                          @click="subTip(subIndex)">
                          {{subItem}}
                      </div>
                  </div>
                </div>
            </div>
            <div class="main-right">
                <!-- 新闻 -->
                <div class="main-right-item" v-if="tabNum === 0">
                  <div v-if="!newsDetailPage">
                    <!-- 搜索栏 -->
                    <div class="search-header">
                      <el-input
                        placeholder="关键字搜索"
                        v-model="searchParams">
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        <el-button slot="append" class="search-btn" @click="searchFun(1)">搜索</el-button>
                      </el-input>
                    </div>
                    <!-- 主题内容 -->
                    <div class="content" v-if="!empty">
                      <div class="news-item "  v-for="(item,index) in tableList" :key="index">
                        <div class="news-item-click" @click="newsDetailClick(item)">
                          <span class="news-item-dec dot red" v-if="item.title.length>30" >{{item.title}}<i class="icon iconfont iconzhiding" :class="{active: item.title.length>30}" v-if="!!item.topEnable"></i></span>
                          <span class="dot red" v-else >{{item.title}}<i class="icon iconfont iconzhiding" v-if="!!item.topEnable"></i></span>
                          <span class="new-time">{{item.publishTime}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="content empty" v-else>
                      <div class="img-box">
                        <img src="../../assets/images/home/empty.png" alt="">
                      </div>
                      <div class="empty-dec">暂无公告</div>
                    </div>
                    <!-- 分页控件 -->
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="newsQuery.current"
                      :page-size="newsQuery.size"
                      layout="total, sizes, prev, pager, next, jumper"
                      background
                      :total="newsQuery.total">
                    </el-pagination>
                  </div>
                  <div class="news" v-else>
                    <i class="iconfont iconfanhui" @click="returnNews"></i>
                    <div class="news-header">
                      <div class="news-header-title">{{newsTitle}}</div>
                      <div class="news-header-time">{{newsTime}}</div>
                    </div>
                    <div class="line"></div>
                    <div class="news-content" v-html="newsDetail">
                    </div>
                  </div>
                </div>
                <!-- 合作伙伴 -->
                <div class="main-right-item logo" v-if="tabNum === 1">
                  <div class="img-box" v-for="(item,index) in imgList" :key="index">
                    <img :src="item.imgSrc" alt="logo">
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
import {RESPONSE_SUCCESS} from "@/constants"
import imgSrc1 from "@/assets/images/home/logo/PDD.png"
import imgSrc2 from "@/assets/images/home/logo/dangdang.png"
import imgSrc3 from "@/assets/images/home/logo/youzan.png"
import imgSrc4 from "@/assets/images/home/logo/suning.png"
import imgSrc5 from "@/assets/images/home/logo/haipaike.png"
import imgSrc6 from "@/assets/images/home/logo/YJ.png"
import imgSrc7 from "@/assets/images/home/logo/mengtui.png"
import imgSrc8 from "@/assets/images/home/logo/mogujie.png"
import imgSrc9 from "@/assets/images/home/logo/douyin.png"
import imgSrc10 from "@/assets/images/home/logo/kuaishou.png"
import imgSrc11 from "@/assets/images/home/logo/weidian.png"
import imgSrc12 from "@/assets/images/home/logo/inyoujinyou.png"
import imgSrc13 from "@/assets/images/home/logo/xiugou.png"
import imgSrc14 from "@/assets/images/home/logo/jiuye.png"
import imgSrc15 from "@/assets/images/home/logo/kuaidi100.png"
import imgSrc16 from "@/assets/images/home/logo/kuaidiwang.png"
import imgSrc17 from "@/assets/images/home/logo/zhuzhukuaidiyun.png"
import imgSrc18 from "@/assets/images/home/logo/yichadan.png"
import imgSrc19 from "@/assets/images/home/logo/kuaidiniao.png"
export default {
  name: "aboutUs",
  components: { },
  data() {
    return {
      asideList:[{
        subTitle:["新闻公告","合作伙伴"]
      }],
      tabNum:0, 
      imgList:[
        {imgSrc: imgSrc1},
        {imgSrc: imgSrc2},
        {imgSrc: imgSrc3},
        {imgSrc: imgSrc4},
        {imgSrc: imgSrc5},
        {imgSrc: imgSrc6},
        {imgSrc: imgSrc7},
        {imgSrc: imgSrc8},
        {imgSrc: imgSrc9},
        {imgSrc: imgSrc10},
        {imgSrc: imgSrc11},
        {imgSrc: imgSrc12},
        {imgSrc: imgSrc13},
        {imgSrc: imgSrc14},
        {imgSrc: imgSrc15},
        {imgSrc: imgSrc16},
        {imgSrc: imgSrc17},
        {imgSrc: imgSrc18},
        {imgSrc: imgSrc19},
      ],
      news: '111111111111111111111',
      news2: '2222222222222222222222222222222222222222222222222222222',
      newsQuery: {
        current: 1,
        size: 10,
        total: 0, // 返回数据来确定
      },
      tableList: [],
      empty: '',
      searchParams: '', // 搜索关键字
      newsDetailPage: false, // 详细新闻页面
      newsTitle: '',
      newsTime: '',
      newsDetail: ''
    }
  },
  created() {
    this.searchFun()
  },
  watch: {
    // tableList: {
    //   handler (newVal){
    //     // this.empty = newVal&&newVal.length > 0 ? false : true
    //   },
    //   deep: true,
    //   immediate: true,
    // }
  },
  methods: {
    /**
     * @description  侧边点击
     */
    subTip(num){
        this.tabNum = num
    },
    /**
     * @description  每页显示的条数
     */
    handleSizeChange(size) {
      console.log('选择页数，这里当前页要改成1');
      this.newsQuery.size = size
      this.newsQuery.current = 1
      this.searchFun()
    },
    /**
     * @description  点击第几页
     */
    handleCurrentChange(current) {
      // 点击第current页，跳转到第几页
      this.newsQuery.current = current
      this.searchFun()
    },
    /**
     * @description  点击关键字搜索
     */
    searchFun(current){
      // 传入参数有current
      if (current) {
        this.newsQuery.current = 1
      }
      // 点击搜索
      let params = {
        current: this.newsQuery.current,
        size: this.newsQuery.size,
        title: this.searchParams
      }
      this.$API.noticePage(params).then(res => {
        if(res.code === RESPONSE_SUCCESS) {
          const {data} = res
          // 赋值页码
          this.newsQuery.current = data.current || 1
          this.newsQuery.size = data.size || 10
          this.newsQuery.total = data.total || 0
          // 时间不要时分秒，可以通过截取的操作
          if(data.records && data.records.length > 0) {
            data.records.forEach((item,index,array) => {
              array[index].publishTime = item ? item.publishTime.split(' ')[0] : ''
            });
          }
          this.tableList = data.records || []
          this.empty =  this.tableList.length>0 ? false : true
          if(this.empty) {
            this.searchParams.length>0? this.$message.warning('没有找到相关公告') : this.$message.warning('暂无公告')
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    /**
     * @description  点击新闻进入
     */
    newsDetailClick(item) {
      // 打开新闻详情页
      let params = { id: item.id }
      this.$API.noticeDetail(params).then(res => {
        if(res.code === RESPONSE_SUCCESS) {
          // 赋值页码
          const {noticeContent, publishTime, title} = res.data
          this.newsDetailPage = true
          this.newsTitle = title
          // 时间不要时分秒，可以通过截取的操作
          this.newsTime = publishTime ? publishTime.split(' ')[0] : ''
          this.newsDetail = noticeContent
        } else {
          this.$message.error(`获取新闻详情失败,${res.msg}`)
        }
      })
    },
    /**
     * @description  返回新闻列表
     */
    returnNews() {
      this.newsDetailPage = false
    }
  },
}
</script>

<style lang="scss" scoped>
  .aboutUs {
    background: #f4f5f7;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
  }
  .aboutUs-wrap {
    padding: 20px 0;
    height: 100%;
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    display: flex;
    .main-left {
      width: 240px;
      box-sizing: border-box;
      margin-right: 20px;
      background: #fff;
      border-radius: 10px;
      .main-left-header {
        position: relative;
        height: 71px;
        width: 100%;
        border-bottom: 1px solid $table-border-color;
        color: #2b2d42;
        font-size: 26px;
        font-weight: 900;
        line-height: 26px;
        padding: 22px 0 22px 20px;
        box-sizing: border-box;
        .line {
          width: 4px;
          height: 28px;
          background: $theme-color;
          border-radius: 2px;
          display: inline-block;
          position: absolute;
          left: 0;
          top: 22px;
        }
      }
      .main-left-aside {
        .main-left-aside-item {
          .title {
            font-size: 14px;
            color: #2b2d42;
            line-height: 14px;
            font-weight: 600;
            margin-top: 27px;
            padding-left: 20px;
          }
          .subTitle {
            font-size: 14px;
            font-weight: 400;
            color: #61666d;
            line-height: 16px;
            text-align: center;
            margin-top: 34px;
            cursor: pointer;
            &.first {
              margin-top: 30px;
            }
            &.active {
              font-weight: 600;
              color: $theme-color;
            }
          }
        }
      }
    }
    .main-right {
      flex: 1;
      background: #fff;
      box-sizing: border-box;
      padding: 40px 36px 40px;
      overflow: auto;
      overflow-x: hidden;
      border-radius: 10px;
      .main-right-item {
        .search-header {
          width: 480px;
          margin-left: auto;
          .search-btn {
            font-size: 14px;
            font-family: PingFang, PingFang-SC;
            font-weight: SC;
            text-align: center;
            background-color: $theme-color;
            color: #ffffff;
          }
        }
        .content {
          width: 100%;
          margin-top: 40px;
          min-height: 600px;
          .news-item {
            font-size: 16px;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            color: #2b2d42;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            height: 60px;
            line-height: 60px;
            border-bottom: 1px solid #eeeeee;
            .news-item-click {
              // 点击新闻，样式
              cursor: pointer;
              span {
                cursor: pointer;
                &:hover{
                  color:#e60012;
                }
              }
            }
            .news-item-dec {
              display: inline-block;
              position: relative;
              width: 500px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              padding-right: 20px;
            }
            .iconzhiding {
              font-size: 14px;
              color: rgb(230, 0, 18);
              margin-left: 10px;
              &.active {
                position: absolute;
                top: 2px;
                right: 0;
              }
            }
            .new-time {
              float: right;
              font-size: 12px;
              font-family: PingFangSC, PingFangSC-Regular;
              font-weight: 400;
              color: #9499a3;
            }
            
          }
          .dot::before {
            width: 5px;
            height: 5px;
            background: rgba(153, 153, 153, 1);
            content: ' ';
            border-radius: 50%;
            display: inline-block;
            margin-bottom: 3px;
            margin-right: 10px;
          }
          .dot.red::before {
            background: #e60012;
          }
        }
        .content.empty {
          text-align: center;
          position: relative;
          width: 100%;
          min-height: 600px;
          .img-box {
            position: absolute;
            width: 192px;
            height: 180px;
            left: calc(50% - 96px);
            top: calc(50% - 90px);;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .empty-dec {
            position: absolute;
            width: 96px;
            height: 16px;
            color:#999999;
            font-weight: 400;
            line-height: 16px;
            left: calc(50% - 48px);
            top: calc(50% + 82px);
          }
        }
        .el-pagination {
          text-align: right;
          margin-top: 30px;
        }
        .news {
          position: relative;
          .iconfanhui {
            cursor: pointer;
            position: absolute;
            top: 5px;
          }
          .news-header {
            text-align: center;
            .news-header-title {
              height: 26px;
              font-size: 26px;
              font-family: PingFangSC, PingFangSC-Medium;
              font-weight: 500;
              text-align: center;
              color: #2b2d42;
              line-height: 26px;
            }
            .news-header-time {
              height: 20px;
              font-size: 14px;
              font-family: PingFangSC, PingFangSC-Regular;
              font-weight: 400;
              color: #9499a3;
              line-height: 20px;
              margin-top: 10px;
            }
          }
          .line {
            width: 840px;
            height: 1px;
            background: #dcdee1;
            margin: 30px 0 30px;
          }
          .news-content {
            width: 832px;
            font-size: 14px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: left;
            color: #61666d;
            line-height: 26px;
            // 图片最大 100%
            ::v-deep img {
              max-width: 100%;
            }
          }
        }
      }
    }
    .main-right-item.logo {
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      .img-box {
        width: 128px;
        height: 72px;
        margin: 0 20px 20px 0;
        img {
          width: 100%;
          height: 100%;
        }
        &:nth-child(6n){
          margin-right: 0;
        }
      }
    }
  }
</style>
